import { render, staticRenderFns } from "./crudTemplate.vue?vue&type=template&id=48eab448&scoped=true&"
import script from "./crudTemplate.vue?vue&type=script&lang=js&"
export * from "./crudTemplate.vue?vue&type=script&lang=js&"
import style0 from "./crudTemplate.vue?vue&type=style&index=0&id=48eab448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eab448",
  null
  
)

export default component.exports